import { Injectable } from "@angular/core";
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, retryWhen } from "rxjs/internal/operators";
import { environment } from "@environments/environment";
import { MicrosoftApplicationInsightsService } from "@services/microsoft-application-insights.service";
import { statusMessages } from "./status-messages";
import { genericRetryStrategy } from "@utilities/strategies/retry.util";

@Injectable()
export class ServerErrorInterceptor implements HttpInterceptor {
  constructor(
    private _microsoftApplicationInsightsService: MicrosoftApplicationInsightsService
  ) {}

  //** INTERCEPTOR PARA FORMATEAR LOS ERRORES DEL FRONT Y DEL BACK */

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return next.handle(req).pipe(
      retryWhen(genericRetryStrategy()),
      catchError((error) => {
        console.log(error);
        // Registrar el error en aplication insigths
        this._microsoftApplicationInsightsService.logError(
          error,
          window.location.href
        );
        let errorMessage = "";
        if (error instanceof ErrorEvent) {
          // Error del clientes
          //alert("Error del clientes")
          errorMessage = `Client-side error: ${error.error.message}`;
        } else {
          // Error del BackEnd
          //alert("Error del BackEnd")
          //console.log('Error: ', error);
          if (error.status == 200) {
            errorMessage = `${statusMessages(error.status, error.error.text)}`;
          } else {
            errorMessage = `Error del servidor: ${statusMessages(
              error.status
            )}`;
          }
        }

        // Reenvio del error modificado.
        return throwError(errorMessage);
      })
    );
  }
}
